import { render, staticRenderFns } from "./TheLpuFilters.vue?vue&type=template&id=f740a8fc&scoped=true&"
import script from "./TheLpuFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheLpuFilters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TheLpuFilters.vue?vue&type=style&index=0&id=f740a8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f740a8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f740a8fc')) {
      api.createRecord('f740a8fc', component.options)
    } else {
      api.reload('f740a8fc', component.options)
    }
    module.hot.accept("./TheLpuFilters.vue?vue&type=template&id=f740a8fc&scoped=true&", function () {
      api.rerender('f740a8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/TheLpuFilters.vue"
export default component.exports